import React, { ReactNode } from 'react';
import { Card } from 'antd';
import './SmallImageCard.less';

export type SmallImageCardProps = {
  image?: string;
  cover?: ReactNode;
  actions?: ReactNode;
  dotMenu?: ReactNode | null;
  coverHeight?: any;
  coverWidth?: any;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const { Meta } = Card;

const TSmallImageCard: React.FC<SmallImageCardProps> = ({
  children,
  image,
  coverHeight,
  coverWidth,
  cover,
  actions,
  dotMenu,
  ...props
}) => {
  return (
    <Card className="t-smallImageCardContainer" bodyStyle={{ padding: '16px' }}>
      <>
        <div>{dotMenu}</div>
        <Meta
          avatar={
            !cover && !!image ? (
              <div className="t-smallImageCardCoverImgWrapper">
                <img
                  style={{ height: coverHeight, width: coverWidth }}
                  src={image}
                  className="t-smallImageCardCoverImg"
                  alt=""
                />
              </div>
            ) : (
              <div style={{ height: coverHeight, width: coverWidth }}>
                {cover}
              </div>
            )
          }
          description={children}
        />
      </>
    </Card>
  );
};

export default TSmallImageCard;
